"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorPage = exports.TopologicalEditorPageConfig = exports.CSS = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const _1 = require(".");
const draw_button_1 = require("../../components/button/draw.button");
const carousel_1 = require("../../components/carousel");
const centeredMessage_1 = require("../../components/centeredMessage");
const icons_1 = require("../../components/icon/icons");
const sidebar_1 = require("../../components/sidebar");
const theme_1 = require("../../components/theme");
const tool_picker_1 = require("../../components/tool.picker");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const capture_preview_1 = require("../../modules/capture.preview/capture.preview");
const collection_view_1 = require("../../modules/collection.view/collection.view");
const map_mode_legend_1 = require("../../modules/map.mode.legend");
const topological_editor_collection_list_1 = require("../../modules/topological.editor.collection.list");
const topological_editor_toolbar_1 = require("../../modules/topological.editor.toolbar");
const services_1 = require("../../services");
const store_1 = require("../../store");
const page_1 = require("../page");
const mm_events_1 = require("./mm.events");
exports.CSS = {
    container: 'c-TopologicalEditor',
    content: 'c-TopologicalEditor__Content',
    divider: 'c-TopologicalEditor__Divider',
    toolpicker: 'c-TopolocalEditor__ToolPicker',
    smallContainer: 'c-TopologicalEditor__SmallContainer',
    overlaySave: 'c-TopologicalEditor__OverlaySave',
    toggleableElement: 'c-ToggleableElement'
};
const Style = {
    [exports.CSS.container]: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row'
    },
    [exports.CSS.content]: {
        width: '80%',
        borderLeft: `1px solid ${theme_1.DefaultTheme.font.color.divider}`,
        position: 'relative'
    },
    [exports.CSS.divider]: {
        width: '100%',
        height: '1px',
        margin: '6px 0',
        background: theme_1.DefaultTheme.font.color.divider
    },
    [exports.CSS.toolpicker]: {
        position: 'absolute',
        top: '12px',
        right: '12px',
        zIndex: 100
    },
    [exports.CSS.smallContainer]: {
        flex: '1',
        overflow: 'hidden'
    },
    [exports.CSS.overlaySave]: {
        position: 'fixed',
        display: 'block',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        'background-color': 'rgba(0,0,0,0.5)',
        'z-index': 200,
        cursor: 'pointer'
    },
    [exports.CSS.toggleableElement]: {
        minHeight: '0',
        flexGrow: '1'
    }
};
(0, theme_1.addStyles)(Style);
exports.TopologicalEditorPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.topologicalEditor,
    path: ['/mapmode/:jobId', '/mapmode/:jobId/:collectionUUID'],
    auth: {
        required: true,
        tokens: [core_api_1.IkeToken.FEATURE_MAP_MODE],
        userLevelBlackList: [core_api_1.IkeUserRole.VIEWER, core_api_1.IkeUserRole.DOWNLOADER]
    },
    layout: { nav: false }
};
class TopologicalEditorPage extends page_1.IkePage {
    constructor() {
        super(exports.TopologicalEditorPageConfig);
        this.controller = new _1.TopologicalEditorController();
        this.streeviewSidebar = new sidebar_1.Sidebar();
        this.collectionSidebar = new sidebar_1.Sidebar();
        this._carousel = null;
        this._carouselCollectionRevision = null;
        services_1.Services.Window.bindNavigateAway(i18n_1.T.DISCARD_CHANGES_CONFIRM, this.checkExit);
        this.events = new mm_events_1.MapModeInputEvents(this);
        this.events.init();
    }
    checkExit() {
        return this.controller.hasChanges;
    }
    onRemove() {
        this.controller.destroy();
        services_1.Services.Window.unbindNavigateAway(this.checkExit);
        services_1.Services.Map.map.getStreetView().setVisible(false);
        this.events.destroy();
    }
    get content() {
        return (0, mithril_1.m)('div', {
            className: `${exports.CSS.content} ${this.controller.contentClassNames}`
        }, [
            this.controller.map.view(),
            tool_picker_1.ToolPicker.view({
                children: this.tools,
                className: exports.CSS.toolpicker
            })
        ]);
    }
    get carousel() {
        const currentRevision = this.controller.selectedCollectionRevision;
        // Return cached carousel if it's for the same collection
        if (this._carousel && this._carouselCollectionRevision === currentRevision) {
            return this._carousel;
        }
        // Update cache using action for the new collection
        this.updateCarousel(currentRevision);
        return this._carousel;
    }
    updateCarousel(currentRevision) {
        // Clear cache if collection changed
        this._carousel = null;
        this._carouselCollectionRevision = currentRevision;
        if (this.controller.selectedCollection) {
            let captures = [];
            this.controller.selectedCollection.forEachField(field => {
                if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                    const captureElements = field.getCaptures().map(capture => capture_preview_1.CapturePreview.view(this.controller.selectedCollection, capture, {
                        type: capture_preview_1.CapturePreviewType.MEDIUM,
                        truesize: false,
                        icon: true,
                        crosshair: false
                    }));
                    captures = captures.concat(captureElements);
                }
            });
            if (captures.length) {
                this._carousel = new carousel_1.Carousel({
                    slides: captures,
                    onSlideChange: (index) => this.onSlideChange(index)
                });
            }
        }
    }
    get tools() {
        var _a;
        return [
            this.controller.selectedCollection && (draw_button_1.DrawButton.view(icons_1.MaterialIcon.ADD, {
                flip: false,
                title: i18n_1.T.TOPO_TOOL_RELOCATE_POLE,
                disabled: false,
                selected: false,
                solidBackground: true,
                onclick: () => this.controller.useTool('relocatePole')
            })),
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.VISIBILITY, {
                flip: false,
                title: i18n_1.T.TOPO_SHOW_HIDE_LABELS,
                disabled: false,
                selected: (_a = this.controller.map.overlay) === null || _a === void 0 ? void 0 : _a.viewCollectionLabels,
                solidBackground: true,
                onclick: () => this.controller.map.overlay.toggleViewTitles()
            }),
            draw_button_1.DrawButton.view(icons_1.MaterialIcon.MAGIC_WAND, {
                title: i18n_1.T.TOPO_TOOL_SNAP,
                selected: false,
                solidBackground: true,
                onclick: () => this.controller.bulkSnap()
            })
        ];
    }
    get editCollectionForm() {
        if (this.controller.selectedCollectionEdit) {
            let carouselOrEmpty = this.carousel;
            let carouselContainer = (0, mithril_1.m)('div', { className: exports.CSS.toggleableElement, style: { display: this.controller.selectedCollectionEdit.isCarouselShown ? 'block' : 'none' } }, carouselOrEmpty !== null ? carouselOrEmpty.view() : centeredMessage_1.CenteredMessage.view(i18n_1.T.NO_CAPTURES));
            return (0, mithril_1.m)('div', { className: exports.CSS.smallContainer }, new collection_view_1.CollectionEdit(this.controller.selectedCollectionEdit).view(carouselContainer));
        }
        return null;
    }
    get jobName() {
        return this.controller.tag ? this.controller.tag.name : '';
    }
    get titleBar() {
        const titleBarParams = {
            title: this.jobName,
            selectedCollectionData: {
                onClick: (e) => {
                    services_1.Services.Window.confirmPageChange(e, services_1.Services.Route.getRouteURL(page_1.IkePageName.collectionMeasure, Object.assign({ d: services_1.Services.Department.current.objectId, t: this.controller.tag.objectId }, (this.controller.selectedCollection) && { collection: this.controller.selectedCollection.uuid })));
                }
            },
            saveButton: {
                disabled: !(this.controller.hasChanges || this.controller.isSaving),
                onClick: () => { this.controller.batchSave(); },
                isSaving: this.controller.isSaving
            }
        };
        return titleBarParams;
    }
    get nodes() {
        if (services_1.Services.Department.current == null) {
            return null;
        }
        if (!services_1.Services.Streetview.isReady) {
            return null;
        }
        if (this.controller.routeCollectionUUID) {
            const collectionSummary = store_1.AppStore.CollectionSummary.getFetchableByUuid(this.controller.routeCollectionUUID).value;
            if (collectionSummary) {
                services_1.Services.Map.isReadyPromise.then(() => {
                    this.controller.setSelectedCollectionRevision(collectionSummary.revision);
                });
            }
        }
        return [
            (0, mithril_1.m)('div', {
                className: exports.CSS.container
            }, [
                this.collectionSidebar.view([
                    topological_editor_toolbar_1.TopologicalEditorToolbar.view(this.titleBar),
                    topological_editor_collection_list_1.TopologicalEditorCollectionList.view({
                        onItemClick: (revision) => {
                            this.controller.setSelectedCollectionRevision(revision);
                            this.controller.zoomToSelectedCollection();
                        },
                        collections: this.controller.collections,
                        selectedRevision: this.controller.selectedCollectionRevision,
                        collectionsEditController: this.controller
                    }),
                    (0, mithril_1.m)('div', { className: exports.CSS.divider }),
                    map_mode_legend_1.MapModeLegend.view()
                ]),
                this.content,
                this.controller.selectedCollectionRevision && this.streeviewSidebar.view([
                    this.editCollectionForm,
                    (0, mithril_1.m)('div', { className: exports.CSS.divider }),
                    (0, mithril_1.m)('div', { className: exports.CSS.smallContainer }, this.controller.streetview.view())
                ])
            ]),
            this.controller.isSaving ? (0, mithril_1.m)('div', { className: exports.CSS.overlaySave }) : null
        ];
    }
    onBeforeUnload() {
        this.controller.collectionEditControllers.forEach((controller) => {
            controller.discardAndDestroyEdit();
        });
    }
    onSlideChange(index) {
        const captureIds = this.controller.getCaptureIds();
        const captureId = captureIds[index];
        if (captureId) {
            this.controller.setSelectedCaptureId(captureId);
        }
    }
}
exports.TopologicalEditorPage = TopologicalEditorPage;
tslib_1.__decorate([
    mobx_1.observable.ref
], TopologicalEditorPage.prototype, "_carousel", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorPage.prototype, "_carouselCollectionRevision", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorPage.prototype, "checkExit", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorPage.prototype, "updateCarousel", null);
tslib_1.__decorate([
    mobx_1.computed
], TopologicalEditorPage.prototype, "jobName", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorPage.prototype, "onSlideChange", null);
//# sourceMappingURL=topological.editor.page.js.map